import { Component, OnInit } from '@angular/core';
import { FormsModule, FormBuilder, FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
//import { State } from 'src/app/models/state.model';
import { FswService } from '@services/fsw.service';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss']
})
export class AddUserComponent implements OnInit {

  StateRecord: any[] | undefined;
  RegionRecord: any[] | undefined;
  [x: string]: any;

  addUserForm!: FormGroup;
  submitted = false;
  success = false;
  status : any;
  message : any;
  showRegion = false;
  showState = false;

  constructor(private formBuilder: FormBuilder, private router: Router, private data: FswService, public sanitizer: DomSanitizer, private toastr: ToastrService) {
  }

  ngOnInit(): void {
    this.addUserForm = this.formBuilder.group({
      stateCode: ['',Validators.required],
      userId: [''],
      password:[''],
      userName: ['', Validators.required],
      roles: ['', Validators.required],
      designation: ['', Validators.required],
      emailId: ['', Validators.required],
      mobileNo: ['', Validators.required],
      regionCode: ['']
      // mobileNo: ['', [Validators.required, Validators.pattern("^[0-9]{10}$")]]

      

    })
    this.getState();
    this.getRegion();

  }

  getState() {
    debugger
    this.data.getState().subscribe(
      (Statedata) => {
        this.StateRecord = Statedata;
        console.log(this.StateRecord);
      }
    )
  }
  getRegion() {
    debugger
    this.data.getRegion().subscribe(
      (Regiondata) => {
        this.RegionRecord = Regiondata;
        console.log(this.RegionRecord);
      }
    )
  }


  onaddUserSubmit() {
    this.submitted = true;
    debugger
    if (this.addUserForm.invalid) {
      return;
    }
    //var role = ["ROLE_SO"]
    //this.addUserForm.controls['roles'].setValue(role);
    var role_value = this.addUserForm.get('roles')?.value;
    if(role_value == "ROLE_SO")
    {
      var role = ["ROLE_SO"]
    }
    else if(role_value == "ROLE_RO")
    {
      var role = ["ROLE_RO"]
    }
    this.addUserForm.controls['roles'].setValue(role);
    var email = this.addUserForm.get('emailId')?.value;
    this.addUserForm.controls['userId'].setValue(email);
    this.addUserForm.controls['password'].setValue('password');


    console.log(this.addUserForm.value);
    this.data.addUser(this.addUserForm.value)
      .subscribe(
        response => {
          this.submitted = true;
         // if (response.status == 200){
          this.toastr.success('User Added Successfully!');
          this.router.navigate(['/edit-user']);
          
          //this.addUserForm.reset({});
          //}
            //this.status = "Success"
         // else if (response.status == 422){
            //this.status = "Error"
            //this.message = "response.message"
         //   this.toastr.error('Error Occured!');
          // }
          // else{
          //   this.status = "Error"
          //   this.toastr.error('Error Occured!');
          // }
            
     },
        error => {
          console.log(error);
          this.toastr.error('Error Occured!');
        });


    
  }
  closeAlert() {
    this.success = false;
  }
  selectedState: any = null;
  selectedRegion: any = null;

  checkExistUserId(event: any) {

    console.log(event.target.value);
  }
  checkExistEmailId(event: any) {

    console.log(event.target.value);
  }
  checkExistMobileNo(event: any) {

    console.log(event.target.value);
  }
  changeRole(e) {  
    console.log(e.target.value); 
    var role_value = e.target.value;
    if(role_value == "ROLE_SO")
    {
      this.showState = true; 
      this.showRegion= false;
    }
    else if(role_value == "ROLE_RO")
    {
      this.showRegion= true; 
      this.showState = false; 
    } 
  }  

}

